import {
  ActivityIcon,
  BellIcon,
  ClockIcon,
  GlobeIcon,
  HomeIcon,
  MailIcon,
  SettingsIcon,
  UsersIcon,
  // Hidden for now — restore alongside the files / api-keys / billing
  // nav entries below: CreditCardIcon, DatabaseIcon, KeyIcon.
} from '@saas-kit/ui/shell/icons';
import type { NavEntry } from '@saas-kit/ui/shell';

export const tenantNav: NavEntry[] = [
  {
    id: 'home',
    to: '/',
    labelKey: 'nav.home',
    icon: HomeIcon,
    end: true,
  },
  {
    id: 'team',
    labelKey: 'nav.team',
    icon: UsersIcon,
    children: [
      {
        id: 'team-members',
        to: '/team',
        end: true,
        labelKey: 'nav.members',
        icon: UsersIcon,
        permission: 'members.read',
      },
      {
        id: 'team-invitations',
        to: '/team/invitations',
        labelKey: 'nav.invitations',
        icon: MailIcon,
        permission: 'members.invite',
      },
      {
        id: 'team-roles',
        to: '/team/roles',
        labelKey: 'nav.roles',
        icon: SettingsIcon,
        permission: 'members.manage',
      },
    ],
  },
  {
    id: 'queue',
    labelKey: 'nav.queue',
    icon: ClockIcon,
    children: [
      {
        id: 'queue-workstation',
        to: '/qms/workstation',
        labelKey: 'nav.queue_workstation',
        icon: ActivityIcon,
        permission: 'qms.tokens.view',
      },
      {
        id: 'queue-setup',
        to: '/qms/setup',
        labelKey: 'nav.queue_setup',
        icon: SettingsIcon,
        permission: 'qms.catalog.view',
      },
      {
        id: 'queue-issue',
        to: '/qms/issue',
        labelKey: 'nav.queue_issue',
        icon: MailIcon,
        permission: 'qms.tokens.issue',
      },
      {
        id: 'queue-displays',
        to: '/qms/displays',
        labelKey: 'nav.queue_displays',
        icon: GlobeIcon,
        permission: 'qms.displays.manage',
      },
    ],
  },
  // Hidden for now — re-enable these entries (and their icon imports
  // above) when files / api-keys / billing are ready to ship.
  // {
  //   id: 'files',
  //   to: '/files',
  //   labelKey: 'nav.files',
  //   icon: DatabaseIcon,
  //   permission: 'files.read',
  // },
  // {
  //   id: 'api-keys',
  //   to: '/api-keys',
  //   labelKey: 'nav.api_keys',
  //   icon: KeyIcon,
  //   permission: 'api_keys.manage',
  // },
  // {
  //   id: 'billing',
  //   to: '/billing',
  //   labelKey: 'nav.billing',
  //   icon: CreditCardIcon,
  //   permission: 'billing.read',
  // },
  {
    id: 'notifications',
    to: '/notifications',
    labelKey: 'nav.notifications',
    icon: BellIcon,
    permission: 'notifications.read',
  },
];
